import { Dispatch } from 'redux';

import { TagPayload } from '@/features/PCP/containers/FilterTagsContainer';
import { setPageNumber } from '@/store/redux/actions/pages/pcp';

import { IReduxActionProps } from './../../../../../Utils/index';

export const SET_FILTER_FUEL = 'SET_FILTER_FUEL';
export const DELETE_FILTER_FUEL = 'DELETE_FILTER_FUEL';
export const RESET_FILTER_FUEL = 'RESET_FILTER_FUEL';

export interface FuelFilterStateProps {
  fuelType?: string[];
  maxFuelConsumption?: number | null;
  maxPowerConsumption?: number | null;
}

export const setFilterFuel = (value: FuelFilterStateProps) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: SET_FILTER_FUEL,
      payload: value,
    });
  };
};

export const deleteFilterFuel = (payload: TagPayload) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: DELETE_FILTER_FUEL,
      payload,
    });
  };
};

export const resetFilterFuel = (): IReduxActionProps => {
  return {
    type: RESET_FILTER_FUEL,
  };
};
